/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveaways_NoInputs */

const id_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const ms_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

const da_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej`)
};

const de_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein`)
};

const en_us2_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const es_es2_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const es_mx2_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fil_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const fr_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const it_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const hu_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem`)
};

const nl_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee`)
};

const no_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nei`)
};

const pl_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie`)
};

const pt_br2_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const pt_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

const ro_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu`)
};

const fi_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei`)
};

const sv_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej`)
};

const vi_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không`)
};

const tr_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayır`)
};

const cs_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne`)
};

const bg_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не`)
};

const ru_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const uk_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ні`)
};

const ar_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا`)
};

const hi_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const th_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่`)
};

const ja_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const zh_cn2_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_hant1_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const ko_components_giveaways_no = /** @type {(inputs: Components_Giveaways_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Components_Giveaways_NoInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveaways_no = /** @type {((inputs?: Components_Giveaways_NoInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveaways_NoInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveaways_no(inputs)
	if (locale === "ms") return ms_components_giveaways_no(inputs)
	if (locale === "da") return da_components_giveaways_no(inputs)
	if (locale === "de") return de_components_giveaways_no(inputs)
	if (locale === "en-US") return en_us2_components_giveaways_no(inputs)
	if (locale === "es-ES") return es_es2_components_giveaways_no(inputs)
	if (locale === "es-MX") return es_mx2_components_giveaways_no(inputs)
	if (locale === "fil") return fil_components_giveaways_no(inputs)
	if (locale === "fr") return fr_components_giveaways_no(inputs)
	if (locale === "it") return it_components_giveaways_no(inputs)
	if (locale === "hu") return hu_components_giveaways_no(inputs)
	if (locale === "nl") return nl_components_giveaways_no(inputs)
	if (locale === "no") return no_components_giveaways_no(inputs)
	if (locale === "pl") return pl_components_giveaways_no(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveaways_no(inputs)
	if (locale === "pt") return pt_components_giveaways_no(inputs)
	if (locale === "ro") return ro_components_giveaways_no(inputs)
	if (locale === "fi") return fi_components_giveaways_no(inputs)
	if (locale === "sv") return sv_components_giveaways_no(inputs)
	if (locale === "vi") return vi_components_giveaways_no(inputs)
	if (locale === "tr") return tr_components_giveaways_no(inputs)
	if (locale === "cs") return cs_components_giveaways_no(inputs)
	if (locale === "bg") return bg_components_giveaways_no(inputs)
	if (locale === "ru") return ru_components_giveaways_no(inputs)
	if (locale === "uk") return uk_components_giveaways_no(inputs)
	if (locale === "ar") return ar_components_giveaways_no(inputs)
	if (locale === "hi") return hi_components_giveaways_no(inputs)
	if (locale === "th") return th_components_giveaways_no(inputs)
	if (locale === "ja") return ja_components_giveaways_no(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveaways_no(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveaways_no(inputs)
	return ko_components_giveaways_no(inputs)
});
export { components_giveaways_no as "components.giveaways.no" }